import Vue from 'vue'
import EventBus from '_shared/EventBus'

const plugin = {
    install(vue,store) {
       
        const signalR = require('@microsoft/signalr')        
       
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(process.env.VUE_APP_ID4Server + "/hubs/userwatcher"
            , { accessTokenFactory: () => store.getters['account/user'].access_token })
            .configureLogging(signalR.LogLevel.Warning)
            .withAutomaticReconnect()
            .build();    
            
            connection.on("useradded", async (user) => {                
                EventBus.$emit('current.useradded',user)               
            });
           
            connection.on("userremoved", async (userId) => {                
                EventBus.$emit('current.userremoved',userId)
            });

        const hubFunctions = {
            start: async () => {
                try {
                    
                    if (connection.state == signalR.HubConnectionState.Disconnected) {
                        await connection.start();
                        console.log("watcher - New SignalR Connected.");                        
                    }else
                        console.log("watcher - SignalR Connected.");
                } catch (err) {
                    console.log(err); 
                    connection.stop();
                    setTimeout(hubFunctions.start, 5000);
                    return;
                }
            },
            stop: () => {                
                connection.stop();
            },

        };

        
        Vue.userwatcher = hubFunctions
        Vue.prototype.$userwatcher = hubFunctions
        window.userwatcher = hubFunctions;
    }
}

export default plugin;